<template>
  <div class="field">
    <label class="mb-2 block"><strong>{{ titulo || 'SELECCIONE BORDES' }}</strong></label>
    <div v-if="cargando" class="flex align-items-center">
      <i class="pi pi-spin pi-spinner mr-2 text-primary"></i> Cargando bordes...
    </div>
    <div v-else class="flex flex-column gap-2 mt-2">
      <!-- data-testid: pruebas automáticas (e2e/) -->
      <div v-for="borde in bordes" :key="borde.id" class="flex align-items-center" :data-testid="'borde-' + borde.id">
        <Checkbox 
          v-model="seleccionados" 
          :inputId="'borde_' + borde.id" 
          name="borde" 
          :value="borde" 
          @change="emitirCambio"
        />
        <label :for="'borde_' + borde.id" class="ml-2 mb-0 cursor-pointer text-700">
          {{ borde.nombre }} 
          <span v-if="borde.precio_venta > 0" class="text-green-600 font-bold ml-1">
            (Bs. {{ borde.precio_venta }})
          </span>
        </label>
      </div>
      <div v-if="bordes.length === 0 && sinConexion" class="text-500 font-italic">
        Bordes no disponibles sin conexión.
      </div>
      <div v-else-if="bordes.length === 0" class="text-500 font-italic">
        No hay bordes disponibles o activos.
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/service/ProductService';
import { useConexion } from '@/stores';
import { leerCatalogo } from '@/services-offline/catalogoLocal';

// Caché a nivel de módulo, por sucursal (el precio de los bordes depende de la sucursal)
const cachedBordes = {};
const fetchingBordesPromise = {};

export default {
  name: 'CheckBordes',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    sucursalId: {
      type: [Number, String],
      default: null
    },
    titulo: {
      type: String,
      default: 'SELECCIONE BORDES EXTRAS'
    }
  },
  data() {
    return {
      bordes: [],
      seleccionados: [],
      cargando: false,
      // Etapa 3A: sin servidor y sin catálogo local de la sucursal
      sinConexion: false,
      productService: null
    };
  },
  created() {
    this.productService = new ProductService();
    this.seleccionados = [...this.modelValue];
  },
  mounted() {
    this.cargarBordes();
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.seleccionados = [...newVal];
      },
      deep: true
    },
    sucursalId() {
      // Si cambia de sucursal se usa (o se descarga) la lista de esa sucursal
      this.cargarBordes();
    }
  },
  methods: {
    cargarBordes() {
      const sucursal = this.sucursalId;
      if (!sucursal) {
        this.bordes = [];
        return;
      }

      if (cachedBordes[sucursal]) {
        this.bordes = cachedBordes[sucursal];
        return;
      }

      if (!fetchingBordesPromise[sucursal]) {
        // Sin red (o si el servidor falla) se usan los bordes del catálogo local de la sucursal
        const desdeServidor = useConexion().modoOffline
          ? Promise.reject(new Error('sin conexión'))
          : this.productService.getBordes(sucursal).then(response => response.productos || []);
        fetchingBordesPromise[sucursal] = desdeServidor.then(bordes => {
          cachedBordes[sucursal] = bordes;
          return { bordes, sinConexion: false };
        }).catch(async err => {
          console.warn("Bordes desde el catálogo local:", err);
          delete fetchingBordesPromise[sucursal];
          const fila = await leerCatalogo(sucursal);
          return { bordes: fila ? fila.bordes || [] : [], sinConexion: !fila };
        });
      }

      this.cargando = true;
      fetchingBordesPromise[sucursal].then(({ bordes, sinConexion }) => {
        // Si la sucursal cambió mientras se descargaba, se ignora la respuesta vieja
        if (this.sucursalId == sucursal) {
          this.bordes = bordes;
          this.sinConexion = sinConexion;
        }
      }).finally(() => {
        this.cargando = false;
      });
    },
    emitirCambio() {
      this.$emit('update:modelValue', this.seleccionados);
      this.$emit('change', this.seleccionados);
    }
  }
}
</script>

<style scoped>
</style>
